import {AdminMaintenanceService} from '../../libs/ui/src';

import {client} from '../apiService';

const _AdminMaintenanceService = new AdminMaintenanceService({client});
export {_AdminMaintenanceService as AdminMaintenanceService};
